import { render, staticRenderFns } from "./InventoryTour.vue?vue&type=template&id=59dbdca4&"
import script from "./InventoryTour.vue?vue&type=script&setup=true&lang=js&"
export * from "./InventoryTour.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InventoryTour.vue?vue&type=style&index=0&id=59dbdca4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports